module.exports = "https://cdn-skillquest.mathletics.com/app/164/assets/fonts/13a82fa49eeaf93d6b525a3dad74942b.woff2";